import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { BoostIcon } from 'src/svgs/BoostIcon';
import { BoostIconLight } from 'src/svgs/BoostIconLight';
import { PosIconProps } from 'src/svgs/SvgWrapper';

export const BoostIconDisplay = (
  props: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'> & {
    isActive?: boolean;
    inactive?: boolean;
  }
) => {
  const { isDarkMode } = useSiteTheme();

  return props.isActive || isDarkMode ? (
    <BoostIconLight
      {...props}
      inactive={props.inactive}
      activeFill={
        props.isActive && isDarkMode
          ? vars.color.iconPrimaryInverted
          : undefined
      }
    />
  ) : (
    <BoostIcon {...props} inactive={props.inactive} />
  );
};
